import ContainerTitle from './ContainerTitle.component';

export default ContainerTitle;
